(function () {
    'use strict';

    var app = angular.module('intro-app');

    // Collect the routes
    app.constant('routes', getRoutes());

    // Configure the routes and route resolvers
    app.config(['$routeProvider', 'routes', routeConfigurator]);
    function routeConfigurator($routeProvider, routes) {

        routes.forEach(function (r) {
            $routeProvider.when(r.url, r.config);
        });
        $routeProvider.otherwise({ redirectTo: '/' });
    }

    // Define the routes 
    function getRoutes() {
        return [
            //{
            //    url: '/',
            //    config: {
            //        title: 'dashboard',
            //        templateUrl: '/app/dashboard/dashboard_error.html?version=4'
            //    }
            //},
            //{
            //    url: '/dashboard_Admin',
            //    config: {
            //        title: 'dashboard',
            //        templateUrl: '/app/dashboard/dashboard_Admin.html?version=4'
            //    }
            //},
            //{
            //    url: '/dashboard_Super',
            //    config: {
            //        title: 'dashboard',
            //        templateUrl: '/app/dashboard/dashboard_Super.html?version=4'
            //    }
            //},
            //// USER
            //{
            //    url: '/user',
            //    config: {
            //        title: 'users',
            //        templateUrl: '/app/user/users.html?version=4'
            //    }
            //},
            //{
            //    url: '/user/:UserId',
            //    config: {
            //        title: 'userDetail',
            //        templateUrl: '/app/user/users.html?version=4'
            //    }
            //},
            //{
            //    url: '/user/:UserId/:UnitaId',
            //    config: {
            //        title: 'userDetail',
            //        templateUrl: '/app/user/users.html?version=4'
            //    }
            //},
            // // LOGS   
            //{
            //    url: '/logs',
            //    config: {
            //        title: 'logs',
            //        templateUrl: '/app/logPush/logPush.html?version=4'
            //    }
            //},
            //// PROFILO
            //{
            //    url: '/profiloCliente',
            //    config: {
            //        title: 'profiloCliente',
            //        templateUrl: '/app/profiloCliente/profiloCliente.html?version=4'
            //    }
            //},              
            ////ATTACH
            //{
            //    url: '/attach',
            //    config: {
            //        title: 'attach',
            //        templateUrl: '/app/attach/attach.html?version=4'
            //    }
            //},
            //{
            //    url: '/attach/:AttachId',
            //    config: {
            //        title: 'attach',
            //        templateUrl: '/app/attach/attach.html?version=4'
            //    }
            //},
            ////T_ATTACH
            //{
            //    url: '/tAttach',
            //    config: {
            //        title: 'tAttach',
            //        templateUrl: '/app/tAttach/tAttach.html?version=4'
            //    }
            //},
            //{
            //    url: '/tAttach/:TAttachId',
            //    config: {
            //        title: 'tAttach',
            //        templateUrl: '/app/tAttach/tAttach.html?version=4'
            //    }
            //},
            ////TSOURCE
            //{
            //    url: '/tSource',
            //    config: {
            //        title: 'tSource',
            //        templateUrl: '/app/tSource/tSource.html?version=4'
            //    }
            //},
            //{
            //    url: '/tSource/:TSourceId',
            //    config: {
            //        title: 'tSource',
            //        templateUrl: '/app/tSource/tSource.html?version=4'
            //    }
            //},
            ////UNITA ORGANIZZATIVA
            //{
            //    url: '/unitaOrganizzativa',
            //    config: {
            //        title: 'unitaOrganizzativa',
            //        templateUrl: '/app/unitaOrganizzativa/unitaOrganizzative.html?version=4'
            //    }
            //},
            //{
            //    url: '/unitaOrganizzativa/:UnitaId',
            //    config: {
            //        title: 'unitaOrganizzativa',
            //        templateUrl: '/app/unitaOrganizzativa/unitaOrganizzative.html?version=4'
            //    }
            //},
            //{
            //    url: '/unitaOrganizzativa/:UnitaId/:UserId',
            //    config: {
            //        title: 'unitaOrganizzativa',
            //        templateUrl: '/app/unitaOrganizzativa/unitaOrganizzative.html?version=4'
            //    }
            //},
            ////DIPENDENTE
            //{
            //    url: '/dipendenti',
            //    config: {
            //        title: 'dipendenti',
            //        templateUrl: '/app/dipendente/dipendente.html?version=4'
            //    }
            //},
            //{
            //    url: '/dipendenti/:DipendenteId',
            //    config: {
            //        title: 'dipendenti',
            //        templateUrl: '/app/dipendente/dipendente.html?version=4'
            //    }
            //}
        ];
    }
})();